export type TokenType = "metric" | "operator" | "number" | "paren"

export interface Token {
  type: TokenType
  value: string
  displayValue?: string // 연산자 표시용 (*, / → ×, ÷)
}

const OPERATORS = ["+", "-", "*", "/"]
const PARENS = ["(", ")"]

/**
 * 수식 문자열을 토큰 배열로 변환
 */
export function tokenizeFormula(formula: string): Token[] {
  if (!formula.trim()) return []

  const tokens: Token[] = []
  // 공백 기준으로 분리하되, 괄호는 별도 처리
  const normalized = formula.replace(/\(/g, " ( ").replace(/\)/g, " ) ").trim()

  const parts = normalized.split(/\s+/).filter(Boolean)

  for (const part of parts) {
    if (OPERATORS.includes(part)) {
      tokens.push({
        type: "operator",
        value: part,
        displayValue: getOperatorDisplay(part),
      })
    } else if (PARENS.includes(part)) {
      tokens.push({
        type: "paren",
        value: part,
      })
    } else if (/^\d+\.?\d*$/.test(part)) {
      tokens.push({
        type: "number",
        value: part,
      })
    } else {
      // 메트릭 key
      tokens.push({
        type: "metric",
        value: part,
      })
    }
  }

  return tokens
}

/**
 * 토큰 배열을 수식 문자열로 변환
 */
export function tokensToFormula(tokens: Token[]): string {
  return tokens.map((t) => t.value).join(" ")
}

/**
 * 연산자 표시용 문자 반환
 */
export function getOperatorDisplay(op: string): string {
  switch (op) {
    case "*":
      return "×"
    case "/":
      return "÷"
    case "-":
      return "−"
    default:
      return op
  }
}

/**
 * 수식에서 메트릭 key 목록 추출
 */
export function extractMetricKeys(formula: string): string[] {
  const tokens = tokenizeFormula(formula)
  const metricKeys = tokens.filter((t) => t.type === "metric").map((t) => t.value)

  return [...new Set(metricKeys)]
}
